import { Grid, Typography } from "@mui/material";
import { useMemo } from "react";

import BarChartCustom from "../../../../../components/shared/chart/BarChartCustom";
import ExecutiveKpiCard from "../ExecutiveKpiCard";
import { ManagementWidgetShell } from "../managementDashboardWidgets";
import { pick } from "../managementDashboardUtils";

const SlaPerformanceSection = ({ loading, error, data, onRetry }) => {
  const byStage = data?.byStage || data?.ByStage || [];
  const byContractor = data?.byContractor || data?.ByContractor || [];

  const stageChart = useMemo(
    () =>
      byStage.map((g) => ({
        x: pick(g, "groupTitle", "GroupTitle"),
        "نقض SLA": pick(g, "breachCount", "BreachCount") ?? 0,
        "انطباق": pick(g, "compliancePercent", "CompliancePercent") ?? 0,
      })),
    [byStage]
  );

  const contractorChart = useMemo(
    () =>
      byContractor.slice(0, 10).map((g) => ({
        x: pick(g, "groupTitle", "GroupTitle"),
        "نقض SLA": pick(g, "breachCount", "BreachCount") ?? 0,
      })),
    [byContractor]
  );

  const kpis = [
    {
      title: "انطباق SLA",
      value: pick(data, "compliancePercent", "CompliancePercent"),
      unit: "%",
    },
    {
      title: "میانگین تأخیر",
      value: pick(data, "averageDelayDays", "AverageDelayDays"),
      unit: "روز",
    },
    {
      title: "نقض SLA",
      value: pick(data, "breachCount", "BreachCount"),
      unit: "مورد",
    },
    {
      title: "کل رصدشده",
      value: pick(data, "totalTrackedCount", "TotalTrackedCount"),
      unit: "درخواست",
    },
  ];

  return (
    <ManagementWidgetShell
      title="هوش SLA"
      subheader="انطباق، تأخیر و نقض به تفکیک مرحله و پیمانکار"
      loading={loading}
      error={error}
      onRetry={onRetry}
    >
      <Grid container spacing={1.5} sx={{ mb: 2 }}>
        {kpis.map((kpi) => (
          <Grid item xs={12} sm={6} md={3} key={kpi.title}>
            <ExecutiveKpiCard
              kpi={{
                title: kpi.title,
                value: kpi.value,
                unit: kpi.unit,
                isAvailable: kpi.value != null,
                metricType: 2,
                comparisonState: 3,
              }}
              loading={loading}
            />
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Typography fontWeight={600} fontSize={14} sx={{ mb: 1 }}>
            SLA به تفکیک مرحله
          </Typography>
          <BarChartCustom
            data={stageChart}
            series={["نقض SLA", "انطباق"]}
            xAxis="x"
            yAxisTitle="تعداد / درصد"
            colors={["#d32f2f", "#2e7d32"]}
            loading={loading}
            className="h-280"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography fontWeight={600} fontSize={14} sx={{ mb: 1 }}>
            نقض SLA — پیمانکاران
          </Typography>
          <BarChartCustom
            data={contractorChart}
            series={["نقض SLA"]}
            xAxis="x"
            yAxisTitle="تعداد"
            colors={["#ed6c02"]}
            loading={loading}
            className="h-280"
          />
        </Grid>
      </Grid>
    </ManagementWidgetShell>
  );
};

export default SlaPerformanceSection;
